import React from 'react';
import { createSelector } from 'reselect';

import StandingText from '../../StandingText';

const getTeams = (state) => state?.gumbo?.gameData?.teams ?? {};

const getTeamStandings = (state, homeOrAway) => {
    const teams = getTeams(state);
    const {
        standings: {
            dataByTeams = {}
        }
    } = state || {};

    const teamStandingsLeague = dataByTeams[teams?.[homeOrAway].league?.id] || {};

    const teamStandings = teamStandingsLeague[teams?.[homeOrAway]?.id] || {};

    let teamTranslatedStandingsText = null;
    if (teamStandings?.divisionRank && teamStandings?.nameShort) {
        teamTranslatedStandingsText = <StandingText divisionRank={teamStandings?.divisionRank} nameShort={teamStandings?.nameShort} />;
    }

    return teamTranslatedStandingsText;
};

const getHomeTeamStandings = (state) => getTeamStandings(state, 'home');
const getAwayTeamStandings = (state) => getTeamStandings(state, 'away');

const getTeamSummaryMatchup = (state) => state?.teamSummaryMatchup ?? {};
const getTz = (state) => state?.config?.tz;

const getIsLoading = (state) => state?.loading?.isLoading;

const getGameOver = (state) => state?.gameOver || {};

const getTiebreakerScenario = (state) => {
    let isActiveTiebreaker = false;
    let endedInTiebreaker = false;
    let tiebreakerWinner;
    let tiebreakerInfo;
    const {
        runsHome,
        runsAway,
        awayIsWinner,
        homeIsWinner,
        currentInning,
        scheduledInnings,
        inningState,
        statusCode,
        abstractGameCode,
        tiebreakerScenario,
        teams,
        xrefId
    } = getGameOver(state);
    if (abstractGameCode === 'L' && runsAway === runsHome && ((scheduledInnings === currentInning && inningState === 'End') || scheduledInnings < currentInning) && !!tiebreakerScenario) {
        isActiveTiebreaker = true;
    }
    if (statusCode === 'FW' || statusCode === 'OW') {
        endedInTiebreaker = true;
        tiebreakerWinner = awayIsWinner ? teams?.away?.abbreviation : teams?.home?.abbreviation;
    }

    return {
        isActiveTiebreaker,
        endedInTiebreaker,
        tiebreakerWinner,
        tiebreakerInfo: {
            ...tiebreakerScenario,
            xrefId
        }
    };
};

const getIsSticky = (state) => {
    const {
        config: {
            isStickyScore
        } = {}
    } = state;
    return isStickyScore;
};

const getStatusCode = (state) => state?.gumbo?.gameData?.status?.statusCode ?? '';

export const getTeamSummaryMatchupState = createSelector(
    [getTeamSummaryMatchup, getHomeTeamStandings, getAwayTeamStandings, getTz, getIsLoading, getTiebreakerScenario, getIsSticky, getStatusCode],
    (teamSummaryMatchup, homeTeamStandings, awayTeamStandings, tz, isLoading, tiebreakerScenario, isStickyScore, statusCode) => {
        return {
            ...teamSummaryMatchup,
            standings: {
                home: homeTeamStandings,
                away: awayTeamStandings
            },
            isLoading,
            tz,
            tiebreakerScenario,
            isStickyScore,
            statusCode
        };
    }
);
